import {
  AppShellProvider,
  AppShell as _AppShell,
  Header,
} from '@inflearn/app-shell/dist/forAntMan';
import { ModalsProvider } from '@inflearn/ds-react-next';

export default function AppShell() {
  return (
    <ModalsProvider>
      <AppShellProvider>
        <_AppShell
          isAntMan
          showChanneltalk
          showMoveTop
          header={<Header disabledSticky={false} isAntMan showLanguageSectionButton={false} />}>
          <></>
        </_AppShell>
      </AppShellProvider>
    </ModalsProvider>
  );
}
